module.exports = __webpack_public_path__ + "static/media/hw_chi_17.95dd642c.flv";